import { MenuItem, TextField, TextFieldProps } from "@mui/material";

import { MapEditorEcologicalFunctionPanelEcologicalFunctionTypeFragment } from "../fragments.generated";

type Props = {
    disabled: boolean;
    label: string;
    options: MapEditorEcologicalFunctionPanelEcologicalFunctionTypeFragment[];
    value: string;
    onChange: (value: string) => void;
};

export default function EcologicalFunctionTypeSelectElement({ label, value, onChange, options, disabled }: Props) {
    const handleOnChange: TextFieldProps["onChange"] = event => {
        onChange(event.target.value);
    };

    return (
        <TextField select disabled={disabled} label={label} value={value} onChange={handleOnChange}>
            {options.map(option => (
                <MenuItem key={option.id} value={option.id} selected={option.id === value}>
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
